import { render, staticRenderFns } from "./courseDiscussion.vue?vue&type=template&id=01f012df&scoped=true"
import script from "./courseDiscussion.vue?vue&type=script&lang=js"
export * from "./courseDiscussion.vue?vue&type=script&lang=js"
import style0 from "./courseDiscussion.vue?vue&type=style&index=0&id=01f012df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f012df",
  null
  
)

export default component.exports